import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ErrorMessage, Loading } from '@Components';
import { useFetchData } from '@CustomHooks';
import { ClientConfiguration } from '@Models';
import { bopsApi } from '@Network';
import { RootState } from '@Store';
import config from '../../config';
import Configure from './configureLink';

const ConfigureContainer = () => {
  const { t } = useTranslation();
  const clientConfiguration = useSelector<RootState, ClientConfiguration | undefined>(
    (state) => state.client?.configuration,
  );
  const readOnlyMasters = clientConfiguration?.readOnlyMasters ?? false;

  const isGs1 = config.isGs1Flavor;
  const configurationLinksApiCall = isGs1 ? bopsApi.getConfigurationLinksGS1 : bopsApi.getConfigurationLinks;

  const { data, isLoading: isLoadingLinks, error, refetch } = useFetchData(configurationLinksApiCall);

  const { data: sources, isLoading: isLoadingSources } = !isGs1
    ? useFetchData(bopsApi.getSources)
    : { data: [], isLoading: false };

  const isLoading = isLoadingLinks || isLoadingSources;

  if (isLoading) {
    return <Loading title={t('Configuration.LoadingLink')} />;
  }

  if (error) {
    return <ErrorMessage internalMessage={`Unable to get configuration links: ${String(error)}`} />;
  }

  return (
    <Configure
      configurationLinks={data || []}
      refetch={refetch}
      sources={sources || []}
      readOnlyMasters={readOnlyMasters}
    />
  );
};

export default ConfigureContainer;
